/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Describes the compliance state of the insurance validation process.
 */
export var jove__external_app__v2__validation__model__ValidationState;

(function (jove__external_app__v2__validation__model__ValidationState) {
  jove__external_app__v2__validation__model__ValidationState["SUCCESS"] = "success";
  jove__external_app__v2__validation__model__ValidationState["PENDING"] = "pending";
  jove__external_app__v2__validation__model__ValidationState["FAIL"] = "fail";
})(jove__external_app__v2__validation__model__ValidationState || (jove__external_app__v2__validation__model__ValidationState = {}));